<template>
  <div class="c-form-item-multi-area-merged">
    <el-cascader
      ref="cascader"
      v-model="innerModelValue"
      :options="areaOptions"
      :props="cascaderProps"
      :show-all-levels="showAllLevels"
      :filterable="filterable"
      collapse-tags
      clearable
      @change="handleChange"
      style="width: 100%"
    />
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script lang="ts" setup>
import { _, computed, watch, ref, useAttrs, onMounted, useCurrentAppInstance } from '@zto/zpage'
import { getAreasRef, loadAreas, getAreaData } from '../../../utils/areaMerged'

import type { GenericObject } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: GenericObject
    prop: string
    showAllLevels: boolean
    filterable: boolean
  }>(),
  {
    showAllLevels: true,
    filterable: false,
  }
)

const cascaderProps = { multiple: true }

const innerModelValue = ref<any>([])

const areaOptions = computed(() => getAreasRef().value)

const cascader = ref<any>()

const handleChange = () => {
  const checkedNodeList = cascader.value.getCheckedNodes().filter((item: any) => !(item.parent && item.parent.checked))
  const newList = checkedNodeList.map((item: any) => item.value)
  props.model[props.prop] = newList
}

</script>

<style scoped>
.example-block {
  margin: 1rem;
}
.example-demonstration {
  margin: 1rem;
}
</style>